import React from "react";
import NavFooter from "../nav/footer";
import FooterBrand from "../brand/footer";

var Footer = function Footer(_ref) {
  var title = _ref.title,
      pages = _ref.pages;
  return React.createElement("footer", {
    className: "footer"
  }, React.createElement("h2", {
    className: "footer__course-name"
  }, title), React.createElement(NavFooter, {
    pages: pages
  }), React.createElement(FooterBrand, null), React.createElement("p", {
    className: "footer__copyright"
  }, "Copyright \xA92019 by Phil Schanely.", React.createElement("br", {
    className: "br--only-md"
  }), "All rights reserved."));
};

export default Footer;